<template>
    <div class="bg-light position-fixed top-50 start-50 translate-middle w-75 border border-danger p-2"
        style="border-radius: 10px">
        <div class="container overflow-auto w-100 p-2" style="max-height:80vh">
            <button class="btn-close float-end mt-3 me-5" @click.prevent="close"></button>
            <h3 class="mt-3">Editar lámina {{ sheetLastInfo.presentation }} / {{ sheetLastInfo.specification }}</h3>
            <div>
                <table class="table table-bordered my-auto mx-auto">
                    <thead>
                        <tr>
                            <th colspan="4"><i>Información previa</i></th>
                        </tr>
                        <tr>
                            <th>Presentación: </th>
                            <td>{{ sheetLastInfo.presentation }}</td>
                            <th>Especificación: </th>
                            <td>{{ sheetLastInfo.specification }}</td>
                        </tr>
                        <tr>
                            <th>Clasificación: </th>
                            <td><strong>{{ sheetLastInfo.scale }}</strong></td>
                            <th>Familia de materia <br> prima asociada: </th>
                            <td>{{ rawMatName }}</td>
                        </tr>
                        <tr>
                            <th>Cantidad de espesores
                                <br>asociados:
                            </th>
                            <td>{{ typesNumber }}</td>
                            <th>Precio <br> asociado: </th>
                            <td>{{ priceValue }}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th colspan="4"><i>Editar lámina</i></th>
                        </tr>
                        <tr>
                            <td colspan="4">
                                <p><strong>Nota: </strong><mark>No podrá editar la familia de materia prima asociada y
                                        tampoco su clasificación.</mark></p>
                                <p><mark>Además, tenga presente que luego de hacer clic en el botón "Actualizar lámina", la
                                        información que
                                        sumistre a continuación, sutituirá por completo la información previa de la
                                        lámina.</mark></p>
                                <p><strong>Atención:</strong> <mark>Los campos que se encuentren vacios al momento de hacer
                                        clic en el botón "Actualizar lámina", contarán como
                                        modifaciones.</mark></p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><i class="requiredFields">* </i> Nueva presentación: </p>
                            </th>
                            <td colspan="2"><input type="text" class="form-control" v-model="editPresentation"></td>
                            <td><mark><input class="form-check-input" type="checkbox" role="switch"
                                        id="notChangePresetation" v-model="notChangePresentation" />
                                    <i> Mantener pesentación previa de la lámina.</i></mark>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><i class="requiredFields">* </i> Nueva especificación/norma: </p>
                            </th>
                            <td colspan="2"><input type="text" class="form-control" v-model="editSpecification"></td>
                            <td><mark><input class="form-check-input" type="checkbox" role="switch"
                                        id="notChangeSpecification" v-model="notChangeSpecification" />
                                    <i> Mantener especifiación/norma previa de la lámina.</i></mark>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><i class="requiredFields">* </i> Asociar nuevo precio: </p>
                            </th>
                            <td colspan="3">
                                <select class="form-select" id="price_id" v-model="editPrice">
                                    <option selected value="0">Opciones disponibles...</option>
                                    <option v-for="price in pricesList" :key="price._id" v-bind:value="price.id">
                                        {{ price.name }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th colspan="2">Añada la nueva clasifcación para la lámina <i>(Espesores disponibles y el valor
                                    en pesos para cada servicio según el espesor)</i>, mediante la plantilla facilitada.
                            </th>
                            <td colspan="2"><button class="btn btn-danger">Descargar plantilla</button></td>

                        </tr>
                        <tr>
                            <td>
                                <h5 class="requiredFields">*</h5>
                            </td>
                            <td><input type="file" ref="file" @change="previewFile()" class="form-control" />
                            </td>
                            <td colspan="2"><mark><input class="form-check-input" type="checkbox" role="switch"
                                        id="notChangeSheetTypes" v-model="notChangeSheetTypes" />
                                    <i> Mantener los tipos de láminas asociados a la lámina anterior.</i></mark>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4"><button class="btn btn-danger" @click.prevent="saveChanges()">Actualizar
                                    lámina</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        sendSheetId: Number,
    },
    data() {
        return {
            //Variables before mount-mounted
            sheetLastInfo: [],
            pricesList: [],
            priceDefault: "lam",
            rawMatName: "",
            typesNumber: null,
            priceValue: 0,
            sheetTypesIds: [],
            //Edit fields
            editPresentation: "",
            editSpecification: "",
            editPrice: 0,
            fileSheetTypes: undefined,
            currentFile: undefined,
            //Variable that can not change
            notChangePresentation: false,
            notChangeSpecification: false,
            notChangeSheetTypes: false,
            //Text at the view
            condition1: "El archivo debe contener los encabezados en la primera fila",
            condition2:
                "Puede agregar todas los registros que considere necesarios (filas).",
            condition3: "No debe alterar la cantidad de campos (columnas).",
            condition4: "El separador de decimales debe ser un punto (.).",
            condition5: "No debe tener separador de miles o millares.",
            condition6:
                "Asegurese de que los campos que tienen caracter como +, -, * o / son tratados como TEXTO en excel. De lo contrario pueden ser tomados como una operacion aritmética.",
            condition7:
                "No utilice ninguno de los siguientes caracteres $ % & | ° =  # ¿ ? ¡ ! '\"';",
            condition8:
                "Guarde el archivo en el mismo formato en que lo descargo (CSV delimitado por comas).",
        }
    },
    watch: {
        sendSheetId(newVal) {
            if (newVal !== null) {
                this.getMainSheet();
            }
        },
    },
    methods: {
        async getMainSheet() {
            try {
                if (!this.sendSheetId) {
                    console.log("Sheet id not defined.");
                    return;
                }
                const res = await axios.get(RUTA_SERVIDOR + "api/sheet/get", {
                    params: {
                        sheet_id: this.sendSheetId,
                    },
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                });
                this.sheetLastInfo = res.data[0];
                this.rawMatName = this.sheetLastInfo.rawMaterial["name"];
                this.typesNumber = this.sheetLastInfo.sheetTypes.length;
                this.priceValue = this.sheetLastInfo.priceId["value"];

                // Capturar el atributo id de cada objeto en sheetTypes
                this.sheetLastInfo.sheetTypes.forEach((sheetType) => {
                    this.sheetTypesIds.push(sheetType.id);
                });
                //console.log(this.sheetLastInfo);
            } catch (err) {
                console.log(`An error has occurred: ${err}`);
            }
        },
        close() {
            this.$emit("close", false)
        },
        previewFile(event) {
            this.fileSheetTypes = this.$refs.file.files;
            // console.log(this.fileSheetTypes);
            this.currentFile = this.fileSheetTypes.item(0);
            // console.log(this.currentFile);
        },
        async saveChanges() {
            try {
                await this.saveSheetChanges();
                await this.saveSheetTypesChanges();
                this.$emit("close", false);
            } catch (error) {
                console.log("An error was ocurred ", error);
                // Maneja el error según sea necesario
            }
        },
        async saveSheetChanges() {
            if ((this.editPresentation === "" && !this.notChangePresentation) || (this.editSpecification === "" && !this.notChangeSpecification)
                || this.editPrice == 0) {
                alert("Los campos están vacios, complete aquellos que son obligatorios marcados con *.");
                this.cleanFields();
            } else {
                let formData = new FormData();
                formData.append("sheet_id", this.sendSheetId);
                this.notChangePresentation ? formData.delete("editPresentation") : formData.append("editPresentation", this.editPresentation);
                this.notChangeSpecification ? formData.delete("editSpecification") : formData.append("editSpecification", this.editSpecification);
                formData.append("price_id", this.editPrice);
                // formData.forEach(element => {
                //   console.log(element)
                // });
                try {
                    let res = await axios.post(
                        RUTA_SERVIDOR + "api/sheet/update",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: "Bearer " + localStorage.getItem("token"),
                            },
                        }
                    );
                    // console.log(res.data);

                    if (!res.data) {
                        console.log("There has been a different error with the data.");
                    } else {
                        alert("Cambios sobre la lámina añadidos");
                    }
                } catch (err) {
                    console.log(`There has been an error ${err}`);
                }
            }
        },
        async saveSheetTypesChanges() {
            if ((this.currentFile === undefined && !this.notChangeSheetTypes) || this.sheetTypesIds.length === 0 || this.sendSheetId == null) {
                alert("Recuerde que debe subir un archivo .csv para actualizar la clasificaión de la lámina")
                this.cleanFields();
            } else {
                if (this.sendSheetId != 0) {
                    let formData = new FormData();
                    formData.append("sheet_type_ids", JSON.stringify(this.sheetTypesIds));
                    formData.append("sheet_id", this.sendSheetId);
                    this.notChangeProfileTypes ? formData.delete("edit_csv_file") : formData.append("edit_csv_file", this.currentFile);
                    try {
                        let res = await axios.post(
                            RUTA_SERVIDOR + "api/sheet/type/update",
                            formData,
                            {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                    Authorization: "Bearer " + localStorage.getItem("token"),
                                },
                            }
                        );
                        console.log(res.data);
                        if (!res.data) {
                            console.log("There has been a different error with the data.");
                        } else {
                            this.editPresentation === "" ? alert("Clasificación para la lámina " + this.sheetLastInfo.presentation + " atualizada con exito!") : alert("Clasificación para el perfil " + this.editPresentation + " atualizada con exito!")
                            this.$emit("close", false);
                        }
                    } catch (err) {
                        console.log(`There has been an error ${err}`);
                    }
                    this.cleanFields();
                    location.reload();
                } else {
                    alert(
                        "Id " + this.sendSheetId + " no encontrado."
                    );
                }
            }
        },
        cleanFields() {
            this.editPresentation = "";
            this.editSpecification = "";
            this.editPrice = 0;
            this.currentFile = undefined;
            this.fileSheetTypes = undefined;
            this.sheetTypesIds = [];
            this.sheetLastInfo = [];
            this.notChangePresentation = false;
            this.notChangeSpecification = false;
            this.notChangeSheetTypes = false;
        }
    },
    mounted() {
        this.getMainSheet();
        axios
            .get(RUTA_SERVIDOR + "api/price/list", {
                params: {
                    price_type: this.priceDefault,
                },
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
            .then((res) => (this.pricesList = res.data))
            .catch((err) => console.log(`There has been an error ${err}`));
    },

}
</script>
<style scoped>
.requiredFields {
    color: #9d0e15;
}
</style>